import React from 'react';
import { Download, ChevronDown, FileText, Sheet, Printer, Box, Image as ImageIcon } from 'lucide-react';
import { toast } from 'sonner';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '../../../components/ui/dropdown-menu';
import { api } from '../../../utils/api';
import { materialsToCSV, downloadBlob } from './materialUtils';

export const ExportMenu = ({ plan, projectName, viewerApi, onPrint, className = '' }) => {
  const slug = (projectName || 'projekt').replace(/[^\wåäöÅÄÖ-]+/g, '_');
  const run = async (fn, ok) => {
    try { await fn(); if (ok) toast.success(ok); } catch (e) { toast.error('Exporten misslyckades'); }
  };
  const need3D = (fn) => () => (viewerApi.current ? fn() : toast.info('3D-modellen är inte klar än'));
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={`op-btn-ghost ${className}`} data-testid="export-menu-btn" disabled={!plan}><Download size={16} />Exportera<ChevronDown size={14} className="text-stone-400" /></button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-xl">
        <DropdownMenuLabel>Välj format</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="export-pdf" onClick={() => run(async () => { const r = await api.downloadMaterialPlanPdf(plan.id); downloadBlob(r.data, `Materialplan_${slug}.pdf`); }, 'PDF nedladdad')}>
          <FileText size={15} className="mr-2" />PDF-rapport</DropdownMenuItem>
        <DropdownMenuItem data-testid="export-excel" onClick={() => run(() => downloadBlob(new Blob([materialsToCSV(plan)], { type: 'text/csv;charset=utf-8' }), `Materiallista_${slug}.csv`), 'Excel-fil nedladdad')}>
          <Sheet size={15} className="mr-2" />Excel (inköpslista)</DropdownMenuItem>
        <DropdownMenuItem data-testid="export-print" onClick={onPrint}><Printer size={15} className="mr-2" />Skriv ut</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="export-glb" onClick={need3D(() => run(async () => downloadBlob(await viewerApi.current.exportGLB(), `3D-modell_${slug}.glb`), '3D-modell nedladdad'))}>
          <Box size={15} className="mr-2" />3D-modell (.glb)</DropdownMenuItem>
        <DropdownMenuItem data-testid="export-png" onClick={need3D(() => run(async () => {
          const a = document.createElement('a'); a.href = viewerApi.current.exportPNG(); a.download = `3D-vy_${slug}.png`; a.click();
        }, 'Bild sparad'))}>
          <ImageIcon size={15} className="mr-2" />Bild av 3D-vyn</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
